<template>
  <span>
    <span v-if="dataIsNaN">—</span>
    <count-to v-else :startVal="sv" :endVal="ev" :decimals="decimals"></count-to>
  </span>
</template>

<script>
import countTo from "@/components/VueCountTo/vue-countTo.vue";
export default {
  components: { countTo },
  props: ["value","decimals"],
  data() {
    return {
      sv: 0,
      ev: 0,
      dataIsNaN: false,
    };
  },
  mounted() {
    this.countData()
  },
  methods: {
    countData() {
      if (
        !isNaN(this.value) &&
        this.value !== null &&
        this.vlaue !== "" &&
        this.value !== undefined
      ) {
        this.dataIsNaN = false;
        this.sv = this.ev;
        this.ev = Number(this.value);
      } else {
        this.dataIsNaN = true;
      }
    },
  },
  watch: {
    value() {
      this.countData();
    },
  },
};
</script>

<style>
</style>